/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolWbTwilightIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-wb-twilight"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M20.65 6.4Q21.05 6.8 21.05 7.33Q21.05 7.85 20.65 8.25L19.93 8.97Q19.52 9.38 18.99 9.38Q18.45 9.38 18.05 8.97Q17.68 8.57 17.68 8.04Q17.68 7.5 18.07 7.1L18.8 6.38Q19.2 6 19.74 6.01Q20.27 6.03 20.65 6.4ZM3 20.98Q2.45 20.98 2.06 20.59Q1.68 20.2 1.68 19.65Q1.68 19.1 2.06 18.71Q2.45 18.32 3 18.32L21 18.32Q21.55 18.32 21.94 18.71Q22.32 19.1 22.32 19.65Q22.32 20.2 21.94 20.59Q21.55 20.98 21 20.98ZM12 3.02Q12 3.02 12.28 3.02Q12.55 3.02 12.94 3.41Q13.32 3.8 13.32 4.35L13.32 5.35Q13.32 5.9 12.94 6.29Q12.55 6.67 12 6.67Q11.45 6.67 11.06 6.29Q10.68 5.9 10.68 5.35L10.68 4.35Q10.68 3.8 11.06 3.41Q11.45 3.02 12 3.02ZM3.35 6.3Q3.75 5.9 4.28 5.9Q4.8 5.9 5.2 6.3L5.92 7.03Q6.33 7.42 6.33 7.96Q6.33 8.5 5.92 8.9Q5.53 9.28 4.99 9.28Q4.45 9.28 4.05 8.88L3.33 8.15Q2.95 7.75 2.96 7.21Q2.98 6.67 3.35 6.3ZM4.67 16.32Q4.67 13.13 6.7 10.9Q8.72 8.68 12 8.68Q15.05 8.68 17.19 10.9Q19.32 13.13 19.32 16.32Z" fill={color} />
    </svg>
  );
}
